function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#999",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.211 8.257v.13c0 .97-.773 1.764-1.719 1.764-.946 0-1.72-.793-1.72-1.765v-.13L.316 7.173A.743.743 0 0 1 0 7.06v4.89c0 1.197.946 2.169 2.114 2.169h10.772c1.168 0 2.114-.972 2.114-2.17v-4.89c-.095.05-.205.082-.315.114L9.21 8.257z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.916 2.969h-1.927v-.781C10.99.984 9.995 0 8.78 0H6.22c-1.216 0-2.21.984-2.21 2.188v.78H2.084A2.071 2.071 0 0 0 0 5.032v.875c0 .282.205.516.474.578L5.779 7.5c.016-.922.774-1.656 1.721-1.656.932 0 1.705.734 1.721 1.656l5.29-1.016A.601.601 0 0 0 15 5.906v-.89c0-1.125-.932-2.047-2.084-2.047zm-7.28-.797c0-.313.27-.563.57-.563h2.573c.316 0 .568.266.568.563v.781h-3.71v-.781z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.382 8.408v-.934c0-.467-.4-.856-.882-.856-.481 0-.882.389-.882.856v.934c0 .467.4.857.882.857.481 0 .882-.39.882-.857z"
}));

function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.833ae9a1.svg";
export { ForwardRef as ReactComponent };